import { useEffect } from 'react';

export type Shortcut = { key: string; handler: (e: KeyboardEvent) => void };

// Places a key types a character. Not `role="combobox"`: the goal field is a button with that role, focus returns
// to it when its list closes on Esc, and counting it as typing left every shortcut dead until something else was clicked.
const isTyping = (el: EventTarget | null) =>
  el instanceof HTMLElement && (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.isContentEditable);

/**
 * Global single-key shortcuts. Ignored while typing, so a goal with an S in it never skips the session, and with ⌘ or
 * Ctrl held, so the browser keeps ⌘R and the rest.
 */
export function useShortcuts(shortcuts: Shortcut[]) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.repeat) return;
      for (const s of shortcuts) {
        if (e.key.toLowerCase() !== s.key.toLowerCase() || e.metaKey || e.ctrlKey || e.altKey) continue;
        if (isTyping(e.target)) return;
        e.preventDefault();
        s.handler(e);
        return;
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [shortcuts]);
}
